import { render, staticRenderFns } from "./DonorLegalForm.vue?vue&type=template&id=043574de"
import script from "./DonorLegalForm.vue?vue&type=script&lang=js"
export * from "./DonorLegalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports